import React from 'react'
import BonusSvg from '@/shared/assets/images/BonusMenuIcon.svg'
import { fromNanoToLocaleBalance } from '../../model'

interface BonusAmountCardProps {
    amountNano: number
}

export const BonusAmountCard: React.FC<BonusAmountCardProps> = ({ amountNano }) => {
    return (
        <div className="flex items-center gap-[6px] py-[6px] px-3 bg-color-dark rounded-full">
            <div className="text-white font-semibold">
                {fromNanoToLocaleBalance(amountNano)}
            </div>
            <div className="fill-color-dark text-color-primary">
                <BonusSvg width={24} height={24} />
            </div>
        </div>
    )
}